import { InformationButton } from "@components/buttons/information";
import { SHHtmlBlock, SHStack } from "@components/design-systems";
import { FeeDetailDTO } from "@models/platform-analysis/entities/steps/fee";
import { PDFFeeAnalysisConfig } from "@pages/platform-analysis/components/buttons/export-pdf/components/sections/fee-analysis/configs";
import { FeeAnalysisLabelConstants } from "@pages/platform-analysis/_id/steps/fee/analysis/constants";

interface LabelLineDetailProps {
  firstProductFeeDetails: FeeDetailDTO[];
  isFamilyLevel?: boolean;
  isExcludePerformanceFees?: boolean;
}

export const LabelLineDetail = ({
  firstProductFeeDetails,
  isFamilyLevel = false,
  isExcludePerformanceFees = false,
}: LabelLineDetailProps) => {
  const hasManyColumns =
    firstProductFeeDetails.length >
    PDFFeeAnalysisConfig.MaxFeeDetailsColumnToDisplayLogo;

  return (
    <SHStack direction={"row"} flex={1} paddingLeft={"6px"}>
      {firstProductFeeDetails.map((feeDetail, index) => {
        const name = !feeDetail.isSmaFees
          ? feeDetail.name
          : isExcludePerformanceFees
          ? FeeAnalysisLabelConstants.SMAFeesExcPerf
          : FeeAnalysisLabelConstants.SMAFees;

        return (
          <SHStack
            key={index}
            flex={1}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={
              isExcludePerformanceFees && feeDetail.isSmaFees && hasManyColumns
                ? "column"
                : "row"
            }
            sx={{
              maxWidth:
                hasManyColumns && feeDetail.isPysRefund ? "50px" : "100%",
              mr: index === 0 ? "15px" : "1.5px",
              ml:
                index === firstProductFeeDetails.length - 1
                  ? isFamilyLevel
                    ? "25px"
                    : "15px"
                  : "1.5px",
            }}
          >
            <SHHtmlBlock
              content={name}
              placeholder={name}
              variant={"body4"}
              textAlign={"center"}
              lineHeight={1}
              fontWeight={400}
            />
            {feeDetail.tooltip && (
              <InformationButton
                title={feeDetail.tooltip.title}
                content={feeDetail.tooltip.description}
              />
            )}
          </SHStack>
        );
      })}
    </SHStack>
  );
};
